export default __webpack_public_path__ + "static/media/brain2.fb587a70.png";